import { Swiper } from 'swiper';
import { View, Log, Utils } from '../vendor/kerneljs';

const VideoPlayer = View.extend({
	events: {
		'click .js--play-button':'playButtonHandler',
		'click .js--play-list-item':'playListItemHandler',
		'click .js--play-list-toggle':'playListToggleHandler'
	},
	initialize:function() {
		// uses global youtube object, must be initialized by referencing YouTube before this bundle is executet
		if ( !window.YT ) {
			Log.er('NO YT FOUND');
			return false;
		}

		this.video = this.find('.js--player');
		this.button = this.find('.js--play-button');
		this.playList = this.find('.js--play-list');
		this.playListItems = this.find('.js--play-list-item');

		this.playListIndex = 0;
		this.playlistLength = this.playListItems.length;

		if ( this.video instanceof HTMLElement ) {
			let playerId = this.video.getAttribute('id'),
				videoId = this.video.dataset.youtubeid,
				playlist = this.video.dataset.playlist,
				options = {
					playerVars: {
						rel: 0,
						listType:'playlist',
						list: playlist
					},
					videoId: videoId,
					height: '100%',
					width: '100%',
					events: {
						'onReady': this.onPlayerReady.bind(this),
						'onStateChange': this.onPlayerStateChange.bind(this)
					}
				};

			this.player = new window.YT.Player(playerId, options);


			let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
			if ( iOS ) Utils.removeClass(this.button, 'is-active');

			if ( this.playList instanceof HTMLElement ) {
				this.initPlayList();
			}
		}
	},
	onPlayerReady:function(event) {
		this.playerReady = true;
		this.addClass('is-ready');
		this.player.setVolume(0);
	},
	onPlayerStateChange:function(event) {
		if ( event.data === window.YT.PlayerState.ENDED ) {
			Utils.addClass(this.button, 'is-active');
			if ( this.playList ) {
				Utils.addClass(this.playList,'is-active');

				//Play next
				this.playListIndex = this.playListIndex + 1 === this.playlistLength ? 0 : this.playListIndex + 1;

				let nextItem = this.playListItems[this.playListIndex];

				[...this.playListItems].map((elem)=>{
					Utils.removeClass(elem, 'is-active');
					return null
				});
				let ytId = nextItem.dataset.youtubeid;
				this.nextPlayListItemTimeout = setTimeout(function(){
					this.startPlayListVideo(ytId);
					Utils.addClass(nextItem, 'is-active');
				}.bind(this), 1000);
			}
		}
	},
	playButtonHandler: function() {
		if ( this.playerReady && this.player?.playVideo ) {
			this.player.playVideo();
			Utils.removeClass(this.button, 'is-active');
			if ( this.playList instanceof HTMLElement ) {
				Utils.removeClass(this.playList,'is-active');
			}
		}
	},
	playListItemHandler: function(event) {
		let videoId = event.currentTarget.dataset.youtubeid,
			index = Math.floor(event.currentTarget.dataset.index);
		[...this.playListItems].map((elem)=>{
			Utils.removeClass(elem, 'is-active');
			return null
		});
		Log.db("event.currentTarget",event.currentTarget)
		Utils.addClass(event.currentTarget, 'is-active');

		this.playListIndex = index;
		clearTimeout(this.nextPlayListItemTimeout);

		this.startPlayListVideo(videoId);
	},
	startPlayListVideo: function(ytId) {
		Log.fn(ytId, this.playListIndex);
		this.playListSlider.slideToLoop(this.playListIndex);
		this.player.loadVideoById(ytId);
		Utils.removeClass(this.button, 'is-active');
		Utils.removeClass(this.playList,'is-active');
	},
	playListToggleHandler: function(event) {
		Utils.toggleClass(this.playList,'is-active');
		if ( Utils.hasClass(this.playList,'is-active') ) {
			this.player.pauseVideo();
		}
	},
	stopVideo: function() {

	},
	initPlayList: function() {
		this.playListSlider = new Swiper(this.find('.js--play-list-inner'), {
			wrapperClass: 'js--play-list-slider',
			navigation: {
				nextEl: '.js--slide-right',
				prevEl: '.js--slide-left'
			},
			buttonDisabledClass: 'is-disabled',
			slideClass: 'js--play-list-item',
			slidesPerView: 5,
			slidesPerGroup: 2,
			spaceBetween: 20,
			simulateTouch : true,
			roundLengths: true,
			touchStartPreventDefault: true,
			touchMoveStopPropagation: true,
			preventClicks: true,
			loop:true,
			breakpoints: {
			   	1279: {
			   		slidesPerView: 4,
					slidesPerGroup: 1
			   	},
				1023: {
					slidesPerView: 3,
					slidesPerGroup: 1
				},
				767: {
					slidesPerView: 2,
					slidesPerGroup: 1
				},
				566: {
					slidesPerView: 1,
					slidesPerGroup: 1
				}
			}
		});
	}
});

(function(){

	let tag = document.createElement('script');

	tag.src = "https://www.youtube.com/iframe_api";
	let firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	window.onYouTubeIframeAPIReady = function() {
		Utils.each(Utils.find('.js--video-player'), function(elem) {
			new VideoPlayer( {el: elem} );
		});
	}

})();

export default VideoPlayer